import { render, staticRenderFns } from "./Payway.vue?vue&type=template&id=e1cabf14&"
import script from "./Payway.vue?vue&type=script&lang=js&"
export * from "./Payway.vue?vue&type=script&lang=js&"
import style0 from "./Payway.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports